import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden-user',
  templateUrl: './forbidden-user.component.html',
  styleUrls: ['./forbidden-user.component.scss']
})
export class ForbiddenUserComponent {
email = sessionStorage.getItem('email')
}
